import React from 'react';
// Icons
import { ReactComponent as Delete } from '@assets/icons/delete.svg';
// Styles
import styles from './MultipleAttachmentItem.module.scss';
// Types
import { MultipleAttachmentItemProps } from './MultipleAttachmentItemProps';

const MultipleAttachmentItem = (props: MultipleAttachmentItemProps) => {
  const { id, name, deleteHandler } = props;

  return (
    <div className={styles.wrapper}>
      <span className={styles.text}>{name}</span>
      <button className={styles.button} type="button" onClick={() => deleteHandler(+id)}>
        <Delete />
      </button>
    </div>
  );
};

export default MultipleAttachmentItem;
